import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconCheckCircleFillExtraSmall = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM12.0051 7.81702C12.7325 6.98575 12.6482 5.72222 11.8169 4.99486C10.9857 4.2675 9.72215 4.35173 8.99479 5.183L7.21473 7.21736L6.44937 6.452C5.66832 5.67095 4.40199 5.67095 3.62094 6.452C2.83989 7.23304 2.83989 8.49937 3.62094 9.28042L5.89794 11.5574C6.28935 11.9488 6.82547 12.1605 7.37871 12.1421C7.93194 12.1237 8.4528 11.8768 8.8173 11.4602L12.0051 7.81702Z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "currentColor"
  }));
}, 'IconCheckCircleFillExtraSmall');
IconCheckCircleFillExtraSmall.displayName = 'IconCheckCircleFillExtraSmall';
export default IconCheckCircleFillExtraSmall;